import { Link } from "react-router-dom";
import { news } from "@/mocks/home";

export default function NewsSection() {
  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-screen-xl px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex items-end justify-between gap-4">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              最新电影资讯
            </h2>
            <p className="mt-2 text-sm text-foreground-600">影院动态、定档预告、票房快讯一眼掌握</p>
          </div>
          <Link
            to="/category"
            className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 md:inline-flex"
          >
            更多资讯
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </Link>
        </div>

        {news.length === 0 ? (
          <p className="rounded-lg border border-dashed border-background-300 bg-background-50 py-12 text-center text-sm text-foreground-500">
            暂无最新资讯
          </p>
        ) : (
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            {news.map((item) => {
              const target = item.movieId ? `/detail/${item.movieId}` : "/category";
              return (
                <Link
                  key={item.id}
                  to={target}
                  className="group flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
                >
                  <div className="flex items-center gap-3">
                    <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.date}</span>
                  </div>
                  <h3 className="text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">
                    {item.summary}
                  </p>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}